<template>
  <VModal ref="dialog" disable-backdrop-click @close="handleClose">
    <template #default="modalProps">
      <div class="rounded shadow-xs w-full max-w-3xl mx-auto">
        <div class="rounded shadow-lg bg-white overflow-hidden">
          <div class="px-4 sm:px-6 py-5 border-b">
            <div class="flex items-center justify-between">
              <div class="flex-1">
                <h1 class="text-sm">Asset Manager</h1>
              </div>

              <div class="flex-none">
                <button
                  type="button"
                  class="rounded-md text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                  @click="modalProps.close"
                >
                  <span class="sr-only">Close</span>
                  <svg
                    class="inline-flex h-6 w-6"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    aria-hidden="true"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M6 18L18 6M6 6l12 12"
                    />
                  </svg>
                </button>
              </div>
            </div>
          </div>
          <div class="p-4 sm:p-6 border-b">
            <UploadAssetsAction :action="storeAssets" />
          </div>
          <div class="p-4 sm:p-6 space-y-8">
            <ul class="grid grid-cols-3 gap-4">
              <li v-for="asset in assets" :key="asset.id" class="flex flex-col space-y-2">
                <div class="aspect-w-1 aspect-h-1 relative">
                  <img
                    :src="asset.url"
                    class="absolute inset-0 w-full h-full object-cover rounded"
                    @click="handleSelectAsset(asset)"
                    @dblclick="handleSelectAsset(asset, true)"
                  />
                </div>
                <div class="text-center">
                  <BaseButton success small @click="removeAsset(asset)"> Remove </BaseButton>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </template>
  </VModal>
</template>

<script>
import UploadAssetsAction from './UploadAssetsAction.vue';

export default {
  name: 'GrapesJsAssetManagerDialog',
  components: {
    UploadAssetsAction,
  },
  props: {
    onLoadAssets: {
      type: Function,
      required: true,
    },
    onStoreAssets: {
      type: Function,
      required: true,
    },
    onSelectAsset: {
      type: Function,
      required: true,
    },
    onRemoveAsset: {
      type: Function,
      required: true,
    },
    onClose: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {
      assets: [],
    };
  },
  created() {
    this.loadAssets();
  },
  methods: {
    async loadAssets() {
      try {
        const response = await this.onLoadAssets();

        this.assets = response.data;
      } catch (error) {
        //
      }
    },
    async storeAssets(data) {
      try {
        await this.onStoreAssets(data);

        this.loadAssets();
      } catch (error) {
        //
      }
    },
    async removeAsset(asset) {
      try {
        await this.onRemoveAsset(asset);

        this.loadAssets();
      } catch (error) {
        //
      }
    },
    handleSelectAsset(asset, close = false) {
      this.onSelectAsset(asset);

      if (close) {
        this.$refs.dialog.close();
      }
    },
    handleClose() {
      this.onClose();
      this.$emit('close');
    },
  },
};
</script>
